import type { ActiveButtonsProps } from '@/components/ActiveButtons/ActiveButtons.types'

export const defaultActiveButtonsProps: ActiveButtonsProps = {
  leftButton: {
    title: 'Open an Account',
    routeName: 'live-registration'
  },
  rightButton: {
    title: 'Try a demo',
    routeName: 'demo-registration'
  },
  dense: false,
  mode: 'light',
  position: 'center'
}
